import { deviceUtil, logUtil, pageUtil } from "@repo/lib-common";
import { PageAdsBuilder } from "./pageAdsBuilder";
import { AdUnitSpecialUseCaseEnum } from "./adUnit";


export interface AdUnitSpecialUseCaseFunctions {
    executeIntextAds(adIndex: number): void;
    executeLoadMoreAds(adIndex: number): void;
    executeNativoAds(adIndex: number): void;
}
export abstract class PageAdsBuilderForSpecialUseCases extends PageAdsBuilder {

    constructor(deviceType: deviceUtil.DeviceTypeEnum, pageType: pageUtil.PageTypeEnum) {
        super(deviceType, pageType);

    }
    executeIntextAds(adIndex: number) {
        if (!this.isEnabled) {
            logUtil.consoleLog("ads are disabled, executeIntextAds will not be executed");
            return;
        }
        const adUnits = this.filterAdUnits({ specialUseCase: AdUnitSpecialUseCaseEnum.intext, specialUseCaseIndex: adIndex });
        logUtil.consoleLog("indext ads:", { adIndex, adUnits });
        if (adUnits && adUnits.length > 0) {
            adUnits.forEach(adUnit => {
                this.refreshOrInitializeAdUnit(adUnit);
            });
        }
    }

    executeLoadMoreAds(adIndex: number) {
        if (!this.isEnabled) {
            logUtil.consoleLog("ads are disabled, executeLoadMoreAds will not be executed");
            return;
        }
        const adUnits = this.filterAdUnits({ specialUseCase: AdUnitSpecialUseCaseEnum.loadMore, specialUseCaseIndex: adIndex });
        logUtil.consoleLog("loadMore ads:", { adIndex, adUnits });
        if (adUnits && adUnits.length > 0) {
            adUnits.forEach(adUnit => {
                this.refreshOrInitializeAdUnit(adUnit);
            });
        }
    }

    executeNativoAds(adIndex: number) {
        if (!this.isEnabled) {
            logUtil.consoleLog("ads are disabled, executeNativoAds will not be executed");
            return;
        }
        const adUnits = this.filterAdUnits({ specialUseCase: AdUnitSpecialUseCaseEnum.nativo, specialUseCaseIndex: adIndex });
        logUtil.consoleLog("nativo ads:", { adIndex, adUnits });
        if (adUnits && adUnits.length > 0) {
            adUnits.forEach(adUnit => {
                this.refreshOrInitializeAdUnit(adUnit);
            });
        }

    }


}